import React, {Fragment} from 'react';
import {Skeleton, Typography, useTheme} from '@mui/material';

import {InfoContainer} from './styles';
import {OdontoInformationSectionProps} from './types';
import {useOdontoProviderDetailsQuery} from 'presentation/modules/guide/odonto/queries/useOdontoProviderDetailsQuery';

export function OdontoInformationSection({provider}: OdontoInformationSectionProps) {
	const {codigo, uf, cidade, tipo} = provider;

	const {palette} = useTheme();
	const {
		data: providerDetail,
		isError,
		isLoading,
	} = useOdontoProviderDetailsQuery({
		cdPrestador: String(codigo),
		nmCidade: cidade,
		dsTipo: tipo,
		cdUf: uf,
	});

	if (isError || providerDetail === null) {
		return null;
	}

	if (isLoading) {
		return <Skeleton width={200} />;
	}

	return (
		<Fragment>
			{providerDetail?.informativo ? (
				<Fragment>
					<InfoContainer>
						<Typography
							color={palette.secondary.main}
							variant="subtitle2"
							fontWeight={600}>
							{providerDetail.informativo.titulo}
						</Typography>
						<Typography variant="body2">
							{providerDetail.informativo.descricao}
						</Typography>
						<Typography textTransform="uppercase" color={palette.primary.main}>
							{providerDetail.informativo.prestadoresSubstitutos.map(
								(item: {nome?: string}) => item?.nome,
							)}
						</Typography>
					</InfoContainer>
				</Fragment>
			) : null}
		</Fragment>
	);
}
